export const msalConfig = {
    auth: {
      clientId: "49241e11-6cd9-46f3-990e-b9cc9910dece",
      authority: "https://login.microsoftonline.com/fa06aff9-551e-417c-85f4-e11f691ff78e", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: "https://p3p-predict.net/",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["User.Read"]
  };
  

  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com"
  };